import React from 'react'
import MainLoader from '../loader/MainLoader'

const SectionHeroBanner = ( { settings, contentCollection, collectionSettings } ) => {
    return (
        <section
            className={`bg-${settings.backgroundColor} bg-overlay`}
            style={settings.backgroundImage ? {
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundImage: `url(${settings.backgroundImage})`,
                '--overlayopacity': settings.backgroundOverlay,
                '--overlaycolor': `var(--bs-${settings.backgroundColor})`
            } : {}}>
            <div className='container py-8 py-lg-10'>
                <div className={`
                    row
                    hero-banner
                    pt-4
                    ${settings && settings.gutter ? `g-${settings.gutter} ` : ''}
                    ${settings && settings.paddingY ? `py-${settings.paddingY} ` : ''}
                    ${settings && settings.hAlign ? `justify-content-${settings.hAlign} ` : ''}
                    ${settings && settings.vAlign ? `align-items-${settings.vAlign} ` : ''}
                    h-100`}>
                    {contentCollection && <MainLoader contentCollection={contentCollection} collectionSettings={collectionSettings}/>}                     
                </div>
            </div>
        </section>
  )
}

export default SectionHeroBanner